import { render, staticRenderFns } from "./AddInvoiceReminderDlg.vue?vue&type=template&id=f819de36&"
import script from "./AddInvoiceReminderDlg.vue?vue&type=script&lang=js&"
export * from "./AddInvoiceReminderDlg.vue?vue&type=script&lang=js&"
import style0 from "./AddInvoiceReminderDlg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports